import { toast } from 'sonner';
import api from '@/lib/api';

export const downloadLetterPdf = async (letter) => {
  try {
    const { data } = await api.get(`/admin/documents/${letter.id}/pdf?t=${Date.now()}`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = `Brief_${letter.document_number}.pdf`;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch {
    toast.error('PDF konnte nicht geladen werden');
  }
};

export const openLetterPdf = async (letter) => {
  try {
    const { data } = await api.get(`/admin/documents/${letter.id}/pdf?t=${Date.now()}`, { responseType: 'blob' });
    window.open(window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' })), '_blank');
  } catch {
    toast.error('PDF konnte nicht geöffnet werden');
  }
};

export const todayDE = () => new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
